










































import { defineComponent, PropType, computed } from '@vue/composition-api';
import MiddleIncomeCard from './components/MiddleIncomeCard/index.vue';
import type { MiddleIncomeData } from '../../types';

export default defineComponent({
  name: 'MiddleIncome',
  components: {
    MiddleIncomeCard,
  },
  props: {
    middleIncomeData: {
      type: Object as PropType<MiddleIncomeData>,
      required: true,
    },
  },
  setup(props) {
    const includeBusiness = computed(() => props?.middleIncomeData?.includeBusiness);
    return {
      includeBusiness,
    };
  },
});
